import { apiAxiosAuth, apiAxiosCMS } from 'services/api';
import { InptuSelectFeaturesSettingsProps } from 'types/InptuSelectFeaturesSettingsProps';
import { returnLabelBySlug } from './functions';

interface RespGetProvidersSettingsProps {
	isSuccess: boolean;
	data: InptuSelectFeaturesSettingsProps[];
}

export async function getFeaturesSettings(
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespGetProvidersSettingsProps = { isSuccess: false, data: [] };
	setIsOpenLoad(true);
	setMessage('Carregando informações');

	await apiAxiosAuth
		.get('features') // Cache de 5 minutos
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;

			if (res.data.length > 0) {
				const newList: InptuSelectFeaturesSettingsProps[] = res.data.map(
					(item: InptuSelectFeaturesSettingsProps) => {
						return { ...item, label: returnLabelBySlug(item.slug) };
					}
				);

				resp.data = newList;
			}
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = [];
			handleNotify(
				error?.message || 'Houve algum erro para buscar as configurações',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}

interface RespSaveOnBackFeatureSelectedProps {
	isSuccess: boolean;
	data: InptuSelectFeaturesSettingsProps | null;
}

export async function saveOnBackFeatureSelected(
	feature: InptuSelectFeaturesSettingsProps,
	affiliate_id: string | number,
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespSaveOnBackFeatureSelectedProps = {
		isSuccess: false,
		data: null
	};
	setIsOpenLoad(true);
	setMessage('Salvando feature');

	let idToSendToBack = null;

	//esses ifs são responsaveis por fazer o toggle do estado do id
	if (feature.affiliate_id === null) {
		idToSendToBack = affiliate_id;
	}

	if (feature.affiliate_id !== null && feature.affiliate_id !== affiliate_id) {
		idToSendToBack = affiliate_id;
	}

	if (feature.affiliate_id !== null && feature.affiliate_id === affiliate_id) {
		idToSendToBack = null;
	}
	//===============================================================

	const payload = {
		affiliate_id: idToSendToBack, //aqui eu ja faço o toggle do estado do id
		name: feature.name,
		slug: feature.slug
	};

	await apiAxiosAuth
		.post('features', payload) // Cache de 5 minutos
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;

			handleNotify('Feature salva com sucesso', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(
				error?.message || 'Houve algum erro para salvar a feature.',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}

interface dataGetProvidersProps {
	created_at: string;
	discount_coupon: string;
	free_shipping_value: number;
	id: string;
	non_editable_pages: null | any;
	updated_at: string;
}

interface RespGetGeneralConfigProps {
	isSuccess: boolean;
	data: dataGetProvidersProps | null;
}

export async function getGeneralConfig(
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespGetGeneralConfigProps = { isSuccess: false, data: null };
	setIsOpenLoad(true);
	setMessage('Carregando informações');

	await apiAxiosCMS
		.get('/general-config') // Cache de 5 minutos
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(
				error?.message || 'Houve algum erro para buscar as configurações',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}

interface RespSaveGeneralConfigProps {
	isSuccess: boolean;
	data: dataGetProvidersProps | null;
}

export async function saveGeneralConfig(
	value: string,
	type: 'discount_coupon' | 'free_shipping_value',
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespSaveGeneralConfigProps = { isSuccess: false, data: null };
	setIsOpenLoad(true);
	setMessage('Salvando');

	const payload: any = {};

	if (type === 'discount_coupon') {
		payload.discount_coupon = value; //precisa ser uma string
	} else {
		payload.free_shipping_value = value === '' ? null : parseInt(value); //precisa ser um numero
	}

	await apiAxiosCMS
		.post('/general-config', payload) // Cache de 5 minutos
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;

			handleNotify('Configuração salva com sucesso', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(
				error?.message || 'Houve algum erro para buscar as configurações',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}
